/* eslint-disable react/no-array-index-key */
import React from "react";
/**
 *
 * @param {Array} props.grades an array of students' grades.
 * @returns The test number and lists of students' grades in an <li> element
 */
const TestPercentage = ({ grades, isOpen }) => {
  const listOfgrades = grades.map((grade, index) => (
    <li key={`key-${index}`}>{`Test ${
      index + 1
    }:\u00A0\u00A0\u00A0\u00A0${grade}%`}</li>
  ));
  return (
    <>
      <div className={`accordion__item ${!isOpen ? "collapsed" : ""}`}>
        <div className="accordion__content">
          <ul>{listOfgrades}</ul>
        </div>
      </div>
    </>
  );
};

export default TestPercentage;
